export default "__VITE_PUBLIC_ASSET__cc573baf__"